import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {  
  Grid,
  Card,
  Button,
  Header,
  Label,
  Icon,
  Input,
  Loader,
  Confirm,
  Popup,
  GridColumn,  
  Dropdown,
  Dimmer,
  Modal,
  Form,
} from 'semantic-ui-react';
import _ from 'lodash';
import { settingsActions } from '../../actions/settings.actions';
import { requestActions } from '../../actions/request.actions';
import { dateTimeFormat, dateFormat } from '../../helpers/timeFormat';
import PropTypes from 'prop-types';
import { history } from '../../helpers';
import { getStatusLabel, getStatusColor, getTypeLabel } from '../../helpers/request';
import moment from 'moment';
import { PaginationContainer } from '../../components/PaginationContainer';
import momentDurationFormatSetup from "moment-duration-format";
import { userConstants } from '../../constants/user.constants';
import { requestConstants } from '../../constants/request.constants';
import { userActions } from '../../actions/user.actions';
import { clockActions } from '../../actions/clock.actions';
import { getWorkStatusLabel, getApprovalStepDescription } from '../../helpers/user';

class RequestScreen extends Component {

  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      requestStatus: 'open',
      approvalCategory: '',
      requests: null,
      search: null,
      confirmOpen: false,
      confirmAction: null,
      confirmRequest: null,
      confirmMessage: null,
      confirmError: null,
      rejectComment: "",
      rejectCommentError: null,
      modalOpen: false,
      modalApproveOpen: false,
      me: null
    };
  }

  static get propTypes() { 
    return { 
        requestStatus: PropTypes.string,
        requests: PropTypes.any,
        confirmOpen: PropTypes.bool,
        confirmAction: PropTypes.string,
        confirmMessage: PropTypes.string,
        confirmRequest: PropTypes.any,
        rejectComment: PropTypes.string,
        me: PropTypes.any,
        loading: PropTypes.bool,
        approveLoading: PropTypes.bool,
    }; 
  }

  componentDidMount() {    
    const { dispatch } = this.props;
    this.handleSearchDebounced = _.debounce(function () {
      this.fetchRequests();
    }, 500);

    dispatch(settingsActions.fetchGlobal());

    // Refresh the profile first, then fetch the work status. The status fetch is
    // gated on localStorage.me, which userActions.me() only writes once its request
    // resolves; chaining avoids the race that intermittently skipped the fetch and
    // hid the "Minha Jornada" card on refresh.
    dispatch(userActions.me()).then(() => {
      let me = localStorage.getItem('me') ? JSON.parse(localStorage.getItem('me')) : null;
      if (me) {
        dispatch(userActions.status(me.Username));
      }
    });

    this.fetchRequests();
  }

  handlePageChange(activePage) {      
      this.setState({ page: activePage }, () => this.fetchRequests());
  }

  handleSearch(search) {    
    this.setState({ search, page: 1 });
    this.handleSearchDebounced();
  }

  fetchRequests(isExport) {
    const { dispatch } = this.props;  
    const { requestStatus, page, search } = this.state;

    dispatch(requestActions.fetch({ page, search, orderBy: "startDate", ascending: false, status: requestStatus, export: isExport ? true : null }));
  }

  approvePending() {
    const { dispatch } = this.props;  
    const { requestStatus, page, search } = this.state;

    dispatch(requestActions.approvePending());
  }

  exportXlsx() {
    this.fetchRequests(true);
  }



  toggleRequestStatus() {
    let { requestStatus } = this.state;
    requestStatus = requestStatus == 'open' ? 'closed' : 'open';

    this.setState({ requestStatus }, () => this.fetchRequests());
  }

  showApprove(request, action) {
    var msg;
    switch(action) {
      case 'approve': msg = `Tem certeza que deseja aprovar a solicitação #${request.Id}?`; break;      
      case 'approvePending': msg = `Tem certeza que deseja aprovar todas as solicitações pendentes?`; break;
      default: msg = `Tem certeza que deseja rejeitar a solicitação #${request.Id}?`; break;
    }
    
    this.setState({
      modalApproveOpen: true,
      confirmAction: action,
      confirmRequest: request,      
      confirmMessage: msg
    });
  }

  closeApprove() {
    this.setState({ modalApproveOpen: false});
  }

  showConfirm(request, action) {
    var msg;
    switch(action) {
      case 'approve': msg = `Tem certeza que deseja aprovar a solicitação #${request.Id}?`; break;
      case 'remove': msg = `Tem certeza que deseja excluir a solicitação #${request.Id}?`; break;
      case 'approvePending': msg = `Tem certeza que deseja aprovar todas as solicitações pendentes?`; break;
      case 'registerInterval': msg = 'Deseja registrar sua saída para intervalo? Sua estação de trabalho será bloqueada em seguida pelo período do intervalo'; break;
      case 'registerIntervalReturn': msg = 'Deseja registrar sua seu retorno do intervalo?'; break;
      default: msg = `Tem certeza que deseja rejeitar a solicitação #${request.Id}?`; break;
    }
    
    this.setState({
      confirmOpen: true,
      confirmAction: action,
      confirmRequest: request,      
      confirmMessage: msg
    });
  }  

  closeConfirm() {
    this.setState({ confirmOpen: false});
  }

  showModal(request) {
    this.setState({ modalOpen: true, confirmRequest: request });
  }
  
  closeModal() {
    this.setState({ modalOpen: false});
  }

  executeConfirm() {
    const { dispatch, settings } = this.props;
    const { confirmRequest, confirmAction, approvalCategory } = this.state;
    
    var promise;
    if (confirmAction == 'approve') {
      if (settings?.globalSettings?.FixedApprovalCategories && !approvalCategory) {
        this.setState({ confirmError: 'Selecione a categoria de aprovação' });
        return;
      }
      promise = dispatch(requestActions.approve(confirmRequest.Id, approvalCategory));
    } else if (confirmAction == 'remove') {
      promise = dispatch(requestActions.remove(confirmRequest.Id));
    } else if (confirmAction === 'approvePending') {
      if (settings?.globalSettings?.FixedApprovalCategories && !approvalCategory) {
        this.setState({ confirmError: 'Selecione a categoria de aprovação' });
        return;
      }
      promise = dispatch(requestActions.approvePending(approvalCategory));
    } else if (confirmAction === 'reject') {
      promise = dispatch(requestActions.reject(confirmRequest.Id));
    }  else if (confirmAction === 'registerInterval' || confirmAction === 'registerIntervalReturn') {
      promise = dispatch(clockActions.registerInterval());
    }
    
    promise.then(() => this.fetchRequests()).then(() => dispatch(userActions.status()));

    this.setState({
      modalApproveOpen: false,
      confirmOpen: false,
      confirmAction: null,
      confirmRequest: null,
      confirmMessage: null
    });
  }

  nl2br(string) {
    return string?.replaceAll('\n', '<br/>');
  }

  executeReject() {
    const { dispatch } = this.props;
    const { confirmRequest, rejectComment } = this.state;
    if (!rejectComment) {
      this.setState({ rejectCommentError: 'Preencha a justificativa' });
    } else {
      dispatch(requestActions.reject(confirmRequest.Id, rejectComment)).then(() => this.fetchRequests());
      this.setState({ modalOpen: false });
    }
  }

  goToCreate() {
    history.push('/request/create');
  }

  renderApprovalChain(request) {
    const steps = _.sortBy(request.Approvals || [], 'Order');
    const rejected = request.Status == requestConstants.STATUS_REJECTED;

    // On a rejected request every step was an approval except the last decided one,
    // which is the step that stopped the chain.
    const decidedOrders = steps.filter((step) => step.Decided).map((step) => step.Order);
    const rejectedOrder = rejected && decidedOrders.length > 0 ? _.max(decidedOrders) : null;

    return steps.map((step) => {
      const isRejection = step.Order === rejectedOrder;
      let icon = 'hourglass half';
      if (step.Decided) {
        icon = isRejection ? 'cancel' : 'check';
      }

      return (
        <Popup
          key={step.Id}
          content={`Etapa ${step.Order + 1}: ${getApprovalStepDescription(step)}`}
          trigger={
            <Label color={step.Decided ? (isRejection ? 'red' : 'green') : undefined}>
              <Icon name={icon} />
              {step.Order + 1}. {step.Decided
                ? `${step.Approver.Name} em ${moment(step.DecidedAt).format('DD/MM/YYYY HH:mm')}`
                : getApprovalStepDescription(step)}
            </Label>
          }
        />
      );
    });
  }

  render() {
    const { requestStatus, rejectCommentError, rejectComment, confirmError } = this.state;
    const { requests, me, userStatus, loading, approveLoading, settings } = this.props;    

    let approvalCategories = [];   
    if (settings.globalSettings?.FixedApprovalCategories) {
      var types = settings.globalSettings?.ApprovalCategories.split("\n");
      types.forEach((title) => {
        approvalCategories.push({ key: title, value: title, text: title });
      });
    }           
    
    return (
      <Fragment>
        <Confirm 
          open={this.state.confirmOpen} 
          content={this.state.confirmMessage} 
          confirmButton='Sim'
          cancelButton='Cancelar'          
          onCancel={() => this.closeConfirm()} 
          onConfirm={() => this.executeConfirm()} />

        <Modal
          open={this.state.modalOpen}>
          <Modal.Header>Rejeitar Solicitação</Modal.Header>
            <Modal.Content>        
              <Modal.Description>              
                <p>
                  Tem certeza que deseja cancelar a solicitação?
                </p>
                <Form.Field>
                  <label>Justificativa</label><br/>
                  <Form.TextArea                    
                    columns={80}
                    rows={3}                
                    value={rejectComment}
                    onChange={(e, data) => this.setState({rejectComment : data.value})} />
                  {rejectCommentError ? <Label color='red'>{rejectCommentError}</Label> : ''}
                </Form.Field>                
              </Modal.Description>
            </Modal.Content>
            <Modal.Actions>
              <Button negative onClick={() => this.closeModal()}>
                Cancelar
              </Button>
              <Button positive onClick={() => this.executeReject()}>
                Sim, rejeitar
              </Button>              
            </Modal.Actions>
        </Modal>

        <Modal
          open={this.state.modalApproveOpen}>
          <Modal.Header>Aprovação</Modal.Header>
            <Modal.Content>        
              <Modal.Description>              
                <Header as='h3'>{this.state.confirmMessage}</Header>
                <div>Situação Atual do Solicitante: <strong>{getWorkStatusLabel(this.state.confirmRequest?.Requester.Status)} {this.state.confirmRequest?.Requester.StatusText ? `(${this.state.confirmRequest?.Requester.StatusText})` : ''}</strong></div>
                {settings && settings.globalSettings?.ApprovalTermEnabled && <div style={{width: '100%', height: '200px', overflow: 'auto', border: '1px solid #CCCCCC', margin: '4px', padding: '4px'}} dangerouslySetInnerHTML={{__html: settings.globalSettings?.ApprovalTerm}}></div>}
                {settings && settings.globalSettings?.FixedApprovalCategories && <Form.Field required>
                <label>Categoria da Aprovação</label>
                  <Dropdown
                    placeholder='Selecione'
                    fluid
                    label='Categoria'
                    selection              
                    onChange={(e, data) => { this.setState({ approvalCategory: data.value}) }}
                    options={approvalCategories}
                  />
              </Form.Field>}
              { confirmError && <Label color='red'>{confirmError}</Label>}
              </Modal.Description>
            </Modal.Content>
            <Modal.Actions>
              <Button negative onClick={() => this.closeApprove()}>
                Cancelar
              </Button>
              <Button positive onClick={() => this.executeConfirm()}>
                Sim, aprovar
              </Button>              
            </Modal.Actions>
        </Modal>
        
        <Grid stackable>
          {me && settings?.globalSettings?.AllowUserCheckStatus && userStatus && <Grid.Row>
              <Card fluid>
                <Card.Content>
                  <Card.Header>
                    <strong>Minha Jornada</strong>                    
                    <Label style={{float: "right"}} color={!userStatus.CanBeBlocked ? '' : (userStatus.Blocked ? 'red' : 'green')}>
                      {!userStatus.CanBeBlocked ? 'Bloqueio Desativado' :  (userStatus.Blocked ? 'Bloqueado' : 'Liberado')}
                    </Label>
                  </Card.Header>                  
                  <Card.Description>
                    <p>Horário Entrada: {userStatus.ClockRegisterStart || userStatus.JourneyStart ? dateTimeFormat(userStatus.ClockRegisterStart || userStatus.JourneyStart) : '-'}</p>
                    <p>Horário Limite: {userStatus.CanBeBlocked ? <strong>{dateTimeFormat(userStatus.JourneyFinish)}</strong> : <strong>Sem Limite</strong>}</p>                                        
                    {me && settings?.globalSettings?.AllowManualIntervalRegister && !userStatus.IntervalStart && <Button style={{float: "right"}} onClick={() => this.showConfirm(null, 'registerInterval')}>
                        <Icon name='clock'></Icon> Registrar Intervalo
                      </Button>}                    
                    {me && settings?.globalSettings?.AllowManualIntervalRegister && userStatus.IntervalStart && !userStatus.IntervalFinish && <Button style={{float: "right"}} onClick={() => this.showConfirm(null, 'registerIntervalReturn')}>
                        <Icon name='clock'></Icon> Encerrar Intervalo
                      </Button>}                    
                  </Card.Description>  
                </Card.Content>              
            </Card>
          </Grid.Row>}
          <Grid.Row>
            <Grid.Column width={12}>
              <Header as='h1'>Solicitações</Header>
            </Grid.Column>
            <Grid.Column width={4} textAlign='right'>
              { me && me.permissions.includes("request.create") && <Button fluid primary onClick={this.goToCreate}>
                <Icon name='plus square' />
                Nova Solicitação
              </Button>}
            </Grid.Column>
          </Grid.Row>          

          <Grid.Row>
            <Grid.Column width={4}>
              <Button.Group>
                <Button color={requestStatus == 'open' ? 'primary' : 'grey'} onClick={() => this.toggleRequestStatus()}>
                  Pendentes
                </Button>
                <Button.Or text='ou' />
                <Button color={requestStatus == 'closed' ? 'primary' : 'grey'} onClick={() => this.toggleRequestStatus()}>
                  Encerradas
                </Button>
              </Button.Group> 
            </Grid.Column>

            <GridColumn textAlign='center' width={6}>
              <Input fluid icon='search' onChange={(e, data) => this.handleSearch(data.value)} placeholder='Procurar...' loading={loading} />
            </GridColumn>

            <Grid.Column width={6} textAlign='right'>
              <Button onClick={() => this.exportXlsx()}><Icon name='file excel' /> Exportar</Button>
              { me && me.permissions?.includes("request.approve") && settings?.globalSettings?.AllowBatchApproval &&
                <Button positive onClick={() => this.showApprove(null, 'approvePending')}><Icon name='check multiple' /> Aprovar Pendentes</Button>
              }
            </Grid.Column>            
          </Grid.Row>          
          <Grid.Row>            
          </Grid.Row>
        </Grid>     
        
        <Loader active={loading}>Carregando...</Loader>

        <Dimmer active={approveLoading}>
          <Loader>Enviando...</Loader>
        </Dimmer>
      
        <Card.Group>          
          { requests.Results && requests.TotalNumberOfRecords == 0 &&
            <Card header='Nenhuma solicitação' fluid />
          }

          { requests.Results && requests.Results.map((request) => {           
            return <Card key={request.Id} color={request.Status == 1 ? 'green' : 'grey'} fluid>
              <Card.Content>
                <Card.Header>
                  <strong>#{request.Id}</strong>
                  <span style={{marginLeft: "4px"}}>{request.Title}</span>
                  <Label style={{float: "right"}} color={getStatusColor(request.Status)}>
                    {getStatusLabel(request.Status)}
                  </Label>
                </Card.Header>
                <Card.Meta>
                  <small>Criado em {dateTimeFormat(request.CreatedAt)} por {request.Author.Name}</small>
                </Card.Meta>
                <Card.Description>
                  <p dangerouslySetInnerHTML={{__html: this.nl2br(request.Description)}}></p>
                  <Popup content="Usuário" trigger={
                    <Label color='grey'>
                      <Icon name='user' />{request.Requester.Name}
                    </Label>} />

                  <Popup content="Tipo" trigger={
                    <Label color='teal'>
                      {getTypeLabel(request.Type)}
                    </Label>} />

                  {(request.Type == 0 || request.Type == requestConstants.TYPE_START) &&
                  <Popup content="Data de Início" trigger={
                  <Label>
                    <Icon name='calendar' />{dateTimeFormat(request.StartDate)}
                  </Label>} />}

                  {(request.Type == requestConstants.TYPE_ADDITIONAL || request.Type == requestConstants.TYPE_FULLDAY || request.Type == requestConstants.TYPE_UNLOCK)  &&
                  <Popup content="Data Autorizada" trigger={
                  <Label>
                    <Icon name='calendar' />{dateFormat(request.StartDate)}
                  </Label>} />}

                  {request.Repeats > 0 && <Popup content="Repete por" trigger={
                  <Label>
                    <Icon name='refresh' />{request.Repeats} dias
                  </Label>} />}

                  {request.Type != requestConstants.TYPE_FULLDAY && request.Type != requestConstants.TYPE_START && request.Type != requestConstants.TYPE_UNLOCK &&
                  <Popup content="Tempo adicional" trigger={
                  <Label>
                    <Icon name='clock' />{moment.duration(request.MinutesAmount, "minutes").format("HH:mm", { trim: false })}
                  </Label>} />}

                  {request.TypeLabel &&
                  <Popup content="Categoria" trigger={
                  <Label>
                    <Icon name='dot circle' />{request.TypeLabel}
                  </Label>} />}

                  {request.Project &&
                  <Popup content="Projeto" trigger={
                  <Label>
                    <Icon name='table' />{request.Project}
                  </Label>} />}

                  {request.ApprovalCategory &&
                  <Popup content="Categoria Aprovação" trigger={
                  <Label>
                    <Icon name='check circle' />{request.ApprovalCategory}
                  </Label>} />}

                  {request.ApprovalsRequired > 1 &&
                  <Popup content="Aprovações Necessárias" trigger={
                  <Label>
                    <Icon name='check circle outline' />{request.ApprovalsGiven}/{request.ApprovalsRequired}
                  </Label>} />}

                  {request.UsesCustomWorkflow && this.renderApprovalChain(request)}

                  {!request.UsesCustomWorkflow && request.Approver && <Popup content={request.Status == requestConstants.STATUS_REJECTED ? 'Rejeitado por' : 'Aprovado por'} trigger={
                    <Label color={getStatusColor(request.Status)}>
                      <Icon name={request.Status == requestConstants.STATUS_REJECTED ? 'cancel' : 'check'} />{request.Approver.Name} em {moment(request.ApprovedAt).format('DD/MM/YYYY HH:mm')}
                      {request.RejectNote && <span>&nbsp;<strong>Justificativa</strong> <i>{request.RejectNote}</i></span>}
                  </Label>} />}
                  {!request.UsesCustomWorkflow && request.Approver2 && <Popup content={request.Status == requestConstants.STATUS_REJECTED ? 'Rejeitado por' : 'Aprovado por'} trigger={
                    <Label color={getStatusColor(request.Status)}>
                      <Icon name={request.Status == requestConstants.STATUS_REJECTED ? 'cancel' : 'check'} />{request.Approver2.Name} em {moment(request.Approved2At).format('DD/MM/YYYY HH:mm')}
                      {request.RejectNote && <span>&nbsp;<strong>Justificativa</strong> <i>{request.RejectNote}</i></span>}
                  </Label>} />}

                  {request.UsesCustomWorkflow && request.RejectNote && request.Status == requestConstants.STATUS_REJECTED &&
                  <Label color={getStatusColor(request.Status)}>
                    <Icon name='cancel' /><strong>Justificativa</strong> <i>{request.RejectNote}</i>
                  </Label>}
                </Card.Description>  
              </Card.Content>
              {request.Status == 1 &&
              <Card.Content extra>
                <Grid stackable columns={2}>
                  <Grid.Row>
                  <Grid.Column textAlign='left'>
                      { me && (me.permissions?.includes("request.approve") || (me.AllowSelfApproval && request.Requester.Id === me.Id)) &&
                      <Fragment>
                        <Button size='mini' positive icon onClick={() => this.showApprove(request, 'approve') }>
                          <Icon name='check' />
                          Aprovar
                        </Button>

                        <Button size='mini' negative icon onClick={() => settings && settings.globalSettings.RequireCommentOnReject ? this.showModal(request) : this.showConfirm(request, 'reject') }>
                          <Icon name='cancel' />
                          Rejeitar
                        </Button>
                      </Fragment>}
                    </Grid.Column>

                    <Grid.Column textAlign='right'>                      
                      { me && me.permissions.includes("request.update") && <Button size='mini' icon onClick={() => history.push(`/request/update/${request.Id}`) }>
                        <Icon name='edit' />
                        Alterar
                      </Button> }

                      { me && me.permissions.includes("request.remove") && <Button size='mini' color='red' icon onClick={() => this.showConfirm(request, 'remove') }>
                        <Icon name='trash' />
                        Excluir
                      </Button> }
                    </Grid.Column>
                  </Grid.Row>   
                </Grid>
              </Card.Content>}            
            </Card>                      
          }) }
        </Card.Group>

        <PaginationContainer registers={requests} onPageChange={(e, { activePage }) => this.handlePageChange(activePage) } />        
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { requests, users, settings } = state;    
  return { 
    requests,
    loading: requests.loading,
    approveLoading: requests.approveLoading,
    settings,
    me: users.me || null,
    userStatus: users.status || null,
  };
}

const connectedRequestScreen = connect(mapStateToProps)(RequestScreen);
export { connectedRequestScreen as RequestScreen };
